import React, { useState } from "react";
import "./styles/App.css";
import Banner from "./components/Banner";
import VPNConsole from "./components/VPNConsole";
import Footer from "./components/Footer";
import Toast from "./components/Toast";

function App() {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  const hideToast = () => {
    setToast(null);
  };

  return (
    <div className="app">
      <Banner />
       <VPNConsole onShowToast={showToast} />
      <Footer />
      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={hideToast} />
      )}
    </div>
  );
}

export default App;
